import ExtenStudClubGrievPage from '../../CampusSharedComponent/CampusDynamicPages/CampusExtenStudClubGrievDynamicPage/ExtenStudClubGrievPage'
import culturalbanner from "../../../assets/CampuLifeImages/culturalbanner.jpg"
import culturalactivity1 from "../../../assets/CampuLifeImages/culturalactivity1.jpg"
import culturalactivity2 from "../../../assets/CampuLifeImages/culturalactivity2.jpg"
import culturalactivity3 from "../../../assets/CampuLifeImages/culturalactivity3.jpg"
const Cultural = () => {
  
   const data = 
    { name:"cultural",
      viewmore:"true",
      viewless:"true",
      hover:true,pagename:"Cultural Club", title: "Cultural Club Activities",
      contentImg:culturalbanner,
      para:"The Cultural Club of Noorul Islam College of Arts and Science is a vibrant platform that nurtures creativity, talent, and cultural appreciation among students. The club actively organizes various events, including dance, music, drama, literary competitions, and art exhibitions, encouraging students to showcase their artistic skills. By celebrating diversity and heritage, the club fosters unity and teamwork among students while enhancing their leadership and communication abilities. It also provides opportunities to participate in inter-college and national-level competitions, bringing pride to the institution.",
      paranext:"Through cultural festivals, workshops, and special performances, the club plays a key role in enriching the campus experience. It aims to inspire students to explore their artistic passions and develop a well-rounded personality.",
      threehover:true
    }
   
   const hoverContent =[
     {  img: culturalactivity1, para1: "Drama in  Arunachala Engineering college", para2: "March 14, 2024" },
     {  img:culturalactivity2, para1: "Our College Students won the cash prize from Arunachala Engineering college ", para2: "March 14, 2024" },
     {  img: culturalactivity3, para1: "Onam Celebration in NICAS", para2: "September 12, 2024" },
     ]
  return (
    <>
   <ExtenStudClubGrievPage data = {data} hoverContent = {hoverContent} />
    </>
  )
}

export default Cultural